module.exports = __webpack_public_path__ + "4b82972b5587f2eac3329ed28c6d4209.svg";